/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetCalendareventCustomerCustomerIdScheduleParams,
  GetCalendareventScheduleParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest,
  TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest,
  TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest,
  TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest,
  TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest,
  TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse,
  TrainWithMeModulesTrainingDtosResponsesRecurringSessionsResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const putCalendarEventIdCall = (
    id: number,
    trainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendar-event/${id}/call`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest, signal
    },
      options);
    }




export const getPutCalendarEventIdCallMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCalendarEventIdCall>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putCalendarEventIdCall>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest>}, TContext> => {

const mutationKey = ['putCalendarEventIdCall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCalendarEventIdCall>>, {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  putCalendarEventIdCall(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutCalendarEventIdCallMutationResult = NonNullable<Awaited<ReturnType<typeof putCalendarEventIdCall>>>
    export type PutCalendarEventIdCallMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest> | undefined
    export type PutCalendarEventIdCallMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutCalendarEventIdCall = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCalendarEventIdCall>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCalendarEventIdCall>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutCalendarEventCallRequest>},
        TContext
      > => {
      return useMutation(getPutCalendarEventIdCallMutationOptions(options), queryClient);
    }
    export const postCalendarEventIdCancel = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendar-event/${id}/cancel`, method: 'POST', signal
    },
      options);
    }




export const getPostCalendarEventIdCancelMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdCancel>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdCancel>>, TError,{id: number}, TContext> => {

const mutationKey = ['postCalendarEventIdCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendarEventIdCancel>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postCalendarEventIdCancel(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendarEventIdCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendarEventIdCancel>>>

    export type PostCalendarEventIdCancelMutationError = ErrorType<unknown>

    export const usePostCalendarEventIdCancel = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdCancel>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendarEventIdCancel>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostCalendarEventIdCancelMutationOptions(options), queryClient);
    }
    export const postCalendarEventIdComplete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendar-event/${id}/complete`, method: 'POST', signal
    },
      options);
    }




export const getPostCalendarEventIdCompleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdComplete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdComplete>>, TError,{id: number}, TContext> => {

const mutationKey = ['postCalendarEventIdComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendarEventIdComplete>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postCalendarEventIdComplete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendarEventIdCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendarEventIdComplete>>>

    export type PostCalendarEventIdCompleteMutationError = ErrorType<unknown>

    export const usePostCalendarEventIdComplete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdComplete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendarEventIdComplete>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostCalendarEventIdCompleteMutationOptions(options), queryClient);
    }
    export const postCalendarEventIdMakeRemote = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendar-event/${id}/make-remote`, method: 'POST', signal
    },
      options);
    }




export const getPostCalendarEventIdMakeRemoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdMakeRemote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdMakeRemote>>, TError,{id: number}, TContext> => {

const mutationKey = ['postCalendarEventIdMakeRemote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendarEventIdMakeRemote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postCalendarEventIdMakeRemote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendarEventIdMakeRemoteMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendarEventIdMakeRemote>>>

    export type PostCalendarEventIdMakeRemoteMutationError = ErrorType<unknown>

    export const usePostCalendarEventIdMakeRemote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdMakeRemote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendarEventIdMakeRemote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostCalendarEventIdMakeRemoteMutationOptions(options), queryClient);
    }
    export const postCalendarEventIdNoShow = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendar-event/${id}/no-show`, method: 'POST', signal
    },
      options);
    }




export const getPostCalendarEventIdNoShowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdNoShow>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdNoShow>>, TError,{id: number}, TContext> => {

const mutationKey = ['postCalendarEventIdNoShow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendarEventIdNoShow>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postCalendarEventIdNoShow(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendarEventIdNoShowMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendarEventIdNoShow>>>

    export type PostCalendarEventIdNoShowMutationError = ErrorType<unknown>

    export const usePostCalendarEventIdNoShow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdNoShow>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendarEventIdNoShow>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostCalendarEventIdNoShowMutationOptions(options), queryClient);
    }
    export const postCalendarEventIdPromoteToStationary = (
    id: number,
    trainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendar-event/${id}/promote-to-stationary`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest, signal
    },
      options);
    }




export const getPostCalendarEventIdPromoteToStationaryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdPromoteToStationary>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdPromoteToStationary>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest>}, TContext> => {

const mutationKey = ['postCalendarEventIdPromoteToStationary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendarEventIdPromoteToStationary>>, {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  postCalendarEventIdPromoteToStationary(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendarEventIdPromoteToStationaryMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendarEventIdPromoteToStationary>>>
    export type PostCalendarEventIdPromoteToStationaryMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest> | undefined
    export type PostCalendarEventIdPromoteToStationaryMutationError = ErrorType<unknown>

    export const usePostCalendarEventIdPromoteToStationary = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdPromoteToStationary>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendarEventIdPromoteToStationary>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPromoteToStationaryRequest>},
        TContext
      > => {
      return useMutation(getPostCalendarEventIdPromoteToStationaryMutationOptions(options), queryClient);
    }
    export const postCalendarEventIdReschedule = (
    id: number,
    trainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendar-event/${id}/reschedule`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest, signal
    },
      options);
    }




export const getPostCalendarEventIdRescheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdReschedule>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdReschedule>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest>}, TContext> => {

const mutationKey = ['postCalendarEventIdReschedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendarEventIdReschedule>>, {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  postCalendarEventIdReschedule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendarEventIdRescheduleMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendarEventIdReschedule>>>
    export type PostCalendarEventIdRescheduleMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest> | undefined
    export type PostCalendarEventIdRescheduleMutationError = ErrorType<unknown>

    export const usePostCalendarEventIdReschedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarEventIdReschedule>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendarEventIdReschedule>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsRescheduleCalendarEventRequest>},
        TContext
      > => {
      return useMutation(getPostCalendarEventIdRescheduleMutationOptions(options), queryClient);
    }
    export const postCalendarevent = (
    trainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendarevent`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest, signal
    },
      options);
    }




export const getPostCalendareventMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarevent>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendarevent>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest>}, TContext> => {

const mutationKey = ['postCalendarevent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendarevent>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postCalendarevent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendareventMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendarevent>>>
    export type PostCalendareventMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest> | undefined
    export type PostCalendareventMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostCalendarevent = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendarevent>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendarevent>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateCalendarEventRequest>},
        TContext
      > => {
      return useMutation(getPostCalendareventMutationOptions(options), queryClient);
    }
    export const getCalendareventCustomerCustomerIdSchedule = (
    customerId: number,
    params?: GetCalendareventCustomerCustomerIdScheduleParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse[]>(
      {url: `/calendarevent/customer/${customerId}/schedule`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCalendareventCustomerCustomerIdScheduleQueryKey = (customerId: number,
    params?: GetCalendareventCustomerCustomerIdScheduleParams,) => {
    return [
    `/calendarevent/customer/${customerId}/schedule`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCalendareventCustomerCustomerIdScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError = ErrorType<unknown>>(customerId: number,
    params?: GetCalendareventCustomerCustomerIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCalendareventCustomerCustomerIdScheduleQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>> = ({ signal }) => getCalendareventCustomerCustomerIdSchedule(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCalendareventCustomerCustomerIdScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>>
export type GetCalendareventCustomerCustomerIdScheduleQueryError = ErrorType<unknown>


export function useGetCalendareventCustomerCustomerIdSchedule<TData = Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError = ErrorType<unknown>>(
 customerId: number,
    params: undefined |  GetCalendareventCustomerCustomerIdScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>,
          TError,
          Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendareventCustomerCustomerIdSchedule<TData = Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetCalendareventCustomerCustomerIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>,
          TError,
          Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendareventCustomerCustomerIdSchedule<TData = Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetCalendareventCustomerCustomerIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCalendareventCustomerCustomerIdSchedule<TData = Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetCalendareventCustomerCustomerIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventCustomerCustomerIdSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCalendareventCustomerCustomerIdScheduleQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCalendareventRecurring = (
    trainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesRecurringSessionsResponse>(
      {url: `/calendarevent/recurring`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest, signal
    },
      options);
    }




export const getPostCalendareventRecurringMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendareventRecurring>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCalendareventRecurring>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest>}, TContext> => {

const mutationKey = ['postCalendareventRecurring'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalendareventRecurring>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postCalendareventRecurring(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCalendareventRecurringMutationResult = NonNullable<Awaited<ReturnType<typeof postCalendareventRecurring>>>
    export type PostCalendareventRecurringMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest> | undefined
    export type PostCalendareventRecurringMutationError = ErrorType<unknown>

    export const usePostCalendareventRecurring = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCalendareventRecurring>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCalendareventRecurring>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsCreateRecurringSessionsRequest>},
        TContext
      > => {
      return useMutation(getPostCalendareventRecurringMutationOptions(options), queryClient);
    }
    export const getCalendareventSchedule = (
    params?: GetCalendareventScheduleParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse[]>(
      {url: `/calendarevent/schedule`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCalendareventScheduleQueryKey = (params?: GetCalendareventScheduleParams,) => {
    return [
    `/calendarevent/schedule`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCalendareventScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getCalendareventSchedule>>, TError = ErrorType<unknown>>(params?: GetCalendareventScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCalendareventScheduleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendareventSchedule>>> = ({ signal }) => getCalendareventSchedule(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCalendareventSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCalendareventScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendareventSchedule>>>
export type GetCalendareventScheduleQueryError = ErrorType<unknown>


export function useGetCalendareventSchedule<TData = Awaited<ReturnType<typeof getCalendareventSchedule>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCalendareventScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendareventSchedule>>,
          TError,
          Awaited<ReturnType<typeof getCalendareventSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendareventSchedule<TData = Awaited<ReturnType<typeof getCalendareventSchedule>>, TError = ErrorType<unknown>>(
 params?: GetCalendareventScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendareventSchedule>>,
          TError,
          Awaited<ReturnType<typeof getCalendareventSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendareventSchedule<TData = Awaited<ReturnType<typeof getCalendareventSchedule>>, TError = ErrorType<unknown>>(
 params?: GetCalendareventScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCalendareventSchedule<TData = Awaited<ReturnType<typeof getCalendareventSchedule>>, TError = ErrorType<unknown>>(
 params?: GetCalendareventScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCalendareventScheduleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCalendareventId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarEventResponse>(
      {url: `/calendarevent/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetCalendareventIdQueryKey = (id: number,) => {
    return [
    `/calendarevent/${id}`
    ] as const;
    }


export const getGetCalendareventIdQueryOptions = <TData = Awaited<ReturnType<typeof getCalendareventId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCalendareventIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendareventId>>> = ({ signal }) => getCalendareventId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCalendareventId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCalendareventIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendareventId>>>
export type GetCalendareventIdQueryError = ErrorType<unknown>


export function useGetCalendareventId<TData = Awaited<ReturnType<typeof getCalendareventId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendareventId>>,
          TError,
          Awaited<ReturnType<typeof getCalendareventId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendareventId<TData = Awaited<ReturnType<typeof getCalendareventId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendareventId>>,
          TError,
          Awaited<ReturnType<typeof getCalendareventId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendareventId<TData = Awaited<ReturnType<typeof getCalendareventId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCalendareventId<TData = Awaited<ReturnType<typeof getCalendareventId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendareventId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCalendareventIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteRecurrenceSeriesId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/recurrence-series/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteRecurrenceSeriesIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecurrenceSeriesId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRecurrenceSeriesId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteRecurrenceSeriesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRecurrenceSeriesId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRecurrenceSeriesId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRecurrenceSeriesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRecurrenceSeriesId>>>

    export type DeleteRecurrenceSeriesIdMutationError = ErrorType<unknown>

    export const useDeleteRecurrenceSeriesId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecurrenceSeriesId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRecurrenceSeriesId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteRecurrenceSeriesIdMutationOptions(options), queryClient);
    }
    export const getRecurrenceSeriesId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesRecurringSessionsResponse>(
      {url: `/recurrence-series/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetRecurrenceSeriesIdQueryKey = (id: number,) => {
    return [
    `/recurrence-series/${id}`
    ] as const;
    }


export const getGetRecurrenceSeriesIdQueryOptions = <TData = Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecurrenceSeriesIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecurrenceSeriesId>>> = ({ signal }) => getRecurrenceSeriesId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRecurrenceSeriesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRecurrenceSeriesId>>>
export type GetRecurrenceSeriesIdQueryError = ErrorType<unknown>


export function useGetRecurrenceSeriesId<TData = Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecurrenceSeriesId>>,
          TError,
          Awaited<ReturnType<typeof getRecurrenceSeriesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecurrenceSeriesId<TData = Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecurrenceSeriesId>>,
          TError,
          Awaited<ReturnType<typeof getRecurrenceSeriesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecurrenceSeriesId<TData = Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRecurrenceSeriesId<TData = Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecurrenceSeriesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRecurrenceSeriesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






